var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav',[_c('b-nav-item',{class:{ 'active': _vm.$route.name === 'habilitaUsuarioE24h' },attrs:{"link-classes":"text-dark","to":{ name: 'habilitaUsuarioE24h' },"exact":""}},[_vm._v("Habilitar Usuário")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }